<script lang="ts">
	import { Icon, Label } from '@repo/commons/components'
	import type { DetailedSelectItemIconProps, DetailedSelectItemLabel } from '@repo/commons/models'

	let {
		label,
		suffixIcon
	}: {
		label?: DetailedSelectItemLabel
		suffixIcon?: DetailedSelectItemIconProps | null
	} = $props()
</script>

<div class="flex items-center gap-2">
	{#if label}
		<Label
			label={label.text}
			variant={label.variant ?? 'default'}
			color={label.color}
			icon={label.icon}
			size="sm"
			iconSize="sm"
		/>
	{/if}
	{#if suffixIcon}
		<Icon name={suffixIcon.name} size={suffixIcon.size} class={suffixIcon.class} />
	{/if}
</div>
